import { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./KazakhstanHivTripInfo.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getKazakhstanTripPreparationDetails,
  getKazakhstanTripPreperaionList,
} from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import InCountry from "../../Components/InCountry/InCountry";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { Seo } from "../../Seo";

const KazakhstanHivTripInfo = () => {
  const data = useSelector(
    (state: RootState) => state.info.kazakhstanTripPreparationDetails,
  );

  const params = useParams();
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const tripPreparationList = useSelector(
    (state: RootState) => state.info.kazakhstanTripPreperaionList,
  );
  const lang = useSelector((state: RootState) => state.info.lang);
  const langs: Record<string, string> = {
    ru: "button_ru",
    kg: "button_ky",
    tj: "button_tg",
    uz: "button_uz",
  };

  useEffect(() => {
    dispatch(getKazakhstanTripPreparationDetails(Number(params.id)));
    dispatch(getKazakhstanTripPreperaionList());
  }, [params]);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const getPath = (button: string, id: number) => {
    switch (button) {
      case "Как подготовиться к поездке, если вы уже знаете о своем ВИЧ — статусе":
        return `/kazakhstan/hiv/trip/${id}`;
      case "Как получать лечение?":
        return `/kazakhstan/hiv/treatment/${id}`;
      case "Где и как сдать анализы?":
        return `/kazakhstan/hiv/analysis/${id}`;
      default:
        return `/kazakhstan/hiv`;
    }
  };

  return (
    <div>
      <Seo
        title="Как мигранту с ВИЧ получать лечение в Казахстане?"
        description="Как взять запас лекарств, оформить доверенность и получать лекарства из своей страны без перерыва в лечении."
        url="https://www.vputi.org/kazakhstan/hiv/trip/1"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство Казахстана / Для мигрантов, живущих с ВИЧ / Как подготовиться к поездке",
            path: "/kazakhstan/hiv/1",
          }}
        />

        <ContactButtons />
        <div className={s.text}>
          <div className={s.title}>{data?.title_1}</div>
          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_1 ?? "" }}
          ></div>

          <div
            className={s.body2}
            dangerouslySetInnerHTML={{ __html: data?.body_2 ?? "" }}
          ></div>
        </div>
        <div className={s.buttons}>
          {Array.isArray(tripPreparationList) &&
            [...tripPreparationList]
              .reverse()
              .filter((el) => el.id !== Number(params.id))
              .map((it) => {
                const field = langs[lang] || "button_ru";
                const buttonText = (it as any)[field] || it.button;

                return (
                  <Link
                    to={getPath(it.button, it.id)}
                    key={it.id}
                    className={s.button}
                    onClick={() => getKazakhstanTripPreparationDetails(it.id)}
                  >
                    {buttonText}
                  </Link>
                );
              })}
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default KazakhstanHivTripInfo;
